/**
 * LogsPage — Системные логи (для Super Admin)
 */
export function LogsPage(): React.JSX.Element {
  const logs = [
    { id: 1, type: 'payment', msg: 'Оплата подписки PRO: Владелец Владимир В.', date: 'Сегодня, 12:40', amount: '+2990 ₽' },
    { id: 2, type: 'error', msg: 'Ошибка AI: Некорректный API ключ у Владельца Артем М.', date: 'Сегодня, 11:20', amount: '' },
    { id: 3, type: 'system', msg: 'Блокировка владельца Иван И. (Нарушение правил)', date: 'Вчера, 18:00', amount: '' },
    { id: 4, type: 'payment', msg: 'Продление подписки: Barber Shop No.1', date: 'Вчера, 15:30', amount: '+990 ₽' },
  ];

  return (
    <div className="p-1">
      <h1>📜 Системные логи</h1>

      <div className="section-title">Последние события</div>

      {logs.map(log => (
        <div key={log.id} className="booking-item" style={{ padding: '15px' }}>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center', width: '100%' }}>
            <div style={{ 
              fontSize: '20px', 
              width: '40px', 
              height: '40px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: log.type === 'error' ? 'rgba(255,59,48,0.1)' : 'rgba(0,122,255,0.1)',
              borderRadius: '12px'
            }}>
              {log.type === 'payment' ? '💰' : log.type === 'error' ? '⚠️' : '⚙️'}
            </div>
            
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '2px' }}>{log.msg}</div>
              <div style={{ fontSize: '11px', color: 'var(--tg-hint)' }}>{log.date}</div>
            </div>

            {log.amount && (
              <div style={{ color: '#34C759', fontWeight: '800', fontSize: '14px' }}>{log.amount}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
